// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-block {
    padding: 3px 20px;
    background: #fff;
    border-radius: 999px;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
    margin-right: 15px;
    margin-bottom: 0px;
    transition: all ease 0.3s;
    border: 1px solid #D7DFE9;
}

.category-block:hover {
    /* transition: all ease 0.3s;
    background: var(--darkblue); */
    color: var(--newOrange);
}

.category-block.active {
    background:  var(--newOrange);
    color: #fff;
    border-color: var(--newOrange) !important;
}

.category-block:hover {
    background:  var(--newOrange);
    color: #fff;
    border-color: var(--newOrange) !important;
}

.category-modal .category-block {
    border: 1px solid #D7DFE9;
}

.categories_area+.category-bttnn,
.categories_area button.category-block {
    margin-bottom: 0px;
}

.categories_area+.category-bttnn {
    width: 131px;
}

.gift_card_header {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    background-color: #fff;
    z-index: 11;

}

.product_listing {
    margin-top: 282px;
}

.toggle_margin {
    margin-top: 353px !important;
}




@media screen and (max-width:992px) {
    .category-block {
        margin-bottom: 15px;
    }
}

@media screen and (max-width:576px) {
    .new_block {
        margin-bottom: 5px !important;
    }
}

@media screen and (min-width:767.99px) and (max-width:991.99px) {
    .product_listing {
        margin-top: 423px;
    }
}

@media screen and (min-width:425px) and (max-width:767px) {
    .product_listing {
        margin-top: 493px;
    }
}


@media screen and (max-width:424.98px) {
    .product_listing {
        margin-top: 576px;
    }

    .toggle_margin {
        margin-top: 400px !important;
    }

}

@media screen and (max-width:320px) {
    .product_listing {
        margin-top: 612px;
    }
}

@media screen and (min-width:992px) {
    .product_listing {
        margin-top: 279px;
    }
}

@media screen and (max-width:992px) {
    .categories_area button.category-block {
        margin-bottom: 15px;
    }
}
@media only screen and (max-width: 1555px){
    .product_listing{
        margin-top: 318px !important;
    }
    
    .product_listing.nologin_navbar{
        margin-top: 279px !important;
    }
    .product_listing.inlogin_navbar{
        margin-top: 279px !important;
    }
    @media only screen and (max-width: 1400px){
        .product_listing.inlogin_navbar{
            margin-top: 276px !important;
        }
    
    }
}



@media screen  and (min-width:768px) and (max-width:991.99px){
    .product_listing{
        margin-top: 522px !important;
    }
    .product_listing.nologin_navbar{
        margin-top: 466px !important;
    }
    .product_listing.inlogin_navbar {
        margin-top: 425px !important;
    }
}
@media screen and (min-width:670px) and (max-width:767.98px){
    .product_listing{
        margin-top: 499px !important;
    }
    .product_listing.nologin_navbar{
        margin-top: 442px !important;
    }
    .product_listing.inlogin_navbar {
        margin-top: 440px !important;
    }
}
@media screen and (min-width:576px) and (max-width:669px){
    .product_listing{
        margin-top: 512px !important;
    }
    .product_listing.nologin_navbar{
        margin-top: 444px !important;
    }
    .product_listing.inlogin_navbar {
        margin-top: 440px !important;
    }
}
@media screen and (max-width:577.98px){

    .product_listing{
        margin-top: 560px !important;
    }
    .product_listing.nologin_navbar{
        margin-top: 491px !important;
    }
}
@media screen and (max-width:576px) {
    .categories-searchh.categories_searchh {
        display: block;
    }
    .product_listing.inlogin_navbar {
        margin-top: 450px !important;
    }

    .categories_area+.category-bttnn {
        margin: 0 auto;
        width: 76px;
    }

    .category-block {
        margin-bottom: 26px;
    }
}
@media screen and (min-width:424px) and (max-width:425px) {
    .product_listing.nologin_navbar {
        margin-top: 557px !important;
    }
    .product_listing.inlogin_navbar {
        margin-top: 541px !important;
    }
}
@media screen and (max-width:423.98px) {
    .product_listing.nologin_navbar {
        margin-top: 495px !important;
    }
    .product_listing.inlogin_navbar {
        margin-top: 450px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/category.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI;kCAC8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,OAAO;IACP,MAAM;IACN,sBAAsB;IACtB,WAAW;;AAEf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;;;;AAKA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;IAChC;;AAEJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;IACA;QACI;YACI,4BAA4B;QAChC;;IAEJ;AACJ;;;;AAIA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;AACJ;AACA;;IAEI;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".category-block {\n    padding: 3px 20px;\n    background: #fff;\n    border-radius: 999px;\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n    margin-right: 15px;\n    margin-bottom: 0px;\n    transition: all ease 0.3s;\n    border: 1px solid #D7DFE9;\n}\n\n.category-block:hover {\n    /* transition: all ease 0.3s;\n    background: var(--darkblue); */\n    color: var(--newOrange);\n}\n\n.category-block.active {\n    background:  var(--newOrange);\n    color: #fff;\n    border-color: var(--newOrange) !important;\n}\n\n.category-block:hover {\n    background:  var(--newOrange);\n    color: #fff;\n    border-color: var(--newOrange) !important;\n}\n\n.category-modal .category-block {\n    border: 1px solid #D7DFE9;\n}\n\n.categories_area+.category-bttnn,\n.categories_area button.category-block {\n    margin-bottom: 0px;\n}\n\n.categories_area+.category-bttnn {\n    width: 131px;\n}\n\n.gift_card_header {\n    position: fixed;\n    width: 100%;\n    left: 0;\n    top: 0;\n    background-color: #fff;\n    z-index: 11;\n\n}\n\n.product_listing {\n    margin-top: 282px;\n}\n\n.toggle_margin {\n    margin-top: 353px !important;\n}\n\n\n\n\n@media screen and (max-width:992px) {\n    .category-block {\n        margin-bottom: 15px;\n    }\n}\n\n@media screen and (max-width:576px) {\n    .new_block {\n        margin-bottom: 5px !important;\n    }\n}\n\n@media screen and (min-width:767.99px) and (max-width:991.99px) {\n    .product_listing {\n        margin-top: 423px;\n    }\n}\n\n@media screen and (min-width:425px) and (max-width:767px) {\n    .product_listing {\n        margin-top: 493px;\n    }\n}\n\n\n@media screen and (max-width:424.98px) {\n    .product_listing {\n        margin-top: 576px;\n    }\n\n    .toggle_margin {\n        margin-top: 400px !important;\n    }\n\n}\n\n@media screen and (max-width:320px) {\n    .product_listing {\n        margin-top: 612px;\n    }\n}\n\n@media screen and (min-width:992px) {\n    .product_listing {\n        margin-top: 279px;\n    }\n}\n\n@media screen and (max-width:992px) {\n    .categories_area button.category-block {\n        margin-bottom: 15px;\n    }\n}\n@media only screen and (max-width: 1555px){\n    .product_listing{\n        margin-top: 318px !important;\n    }\n    \n    .product_listing.nologin_navbar{\n        margin-top: 279px !important;\n    }\n    .product_listing.inlogin_navbar{\n        margin-top: 279px !important;\n    }\n    @media only screen and (max-width: 1400px){\n        .product_listing.inlogin_navbar{\n            margin-top: 276px !important;\n        }\n    \n    }\n}\n\n\n\n@media screen  and (min-width:768px) and (max-width:991.99px){\n    .product_listing{\n        margin-top: 522px !important;\n    }\n    .product_listing.nologin_navbar{\n        margin-top: 466px !important;\n    }\n    .product_listing.inlogin_navbar {\n        margin-top: 425px !important;\n    }\n}\n@media screen and (min-width:670px) and (max-width:767.98px){\n    .product_listing{\n        margin-top: 499px !important;\n    }\n    .product_listing.nologin_navbar{\n        margin-top: 442px !important;\n    }\n    .product_listing.inlogin_navbar {\n        margin-top: 440px !important;\n    }\n}\n@media screen and (min-width:576px) and (max-width:669px){\n    .product_listing{\n        margin-top: 512px !important;\n    }\n    .product_listing.nologin_navbar{\n        margin-top: 444px !important;\n    }\n    .product_listing.inlogin_navbar {\n        margin-top: 440px !important;\n    }\n}\n@media screen and (max-width:577.98px){\n\n    .product_listing{\n        margin-top: 560px !important;\n    }\n    .product_listing.nologin_navbar{\n        margin-top: 491px !important;\n    }\n}\n@media screen and (max-width:576px) {\n    .categories-searchh.categories_searchh {\n        display: block;\n    }\n    .product_listing.inlogin_navbar {\n        margin-top: 450px !important;\n    }\n\n    .categories_area+.category-bttnn {\n        margin: 0 auto;\n        width: 76px;\n    }\n\n    .category-block {\n        margin-bottom: 26px;\n    }\n}\n@media screen and (min-width:424px) and (max-width:425px) {\n    .product_listing.nologin_navbar {\n        margin-top: 557px !important;\n    }\n    .product_listing.inlogin_navbar {\n        margin-top: 541px !important;\n    }\n}\n@media screen and (max-width:423.98px) {\n    .product_listing.nologin_navbar {\n        margin-top: 495px !important;\n    }\n    .product_listing.inlogin_navbar {\n        margin-top: 450px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
